const textHeight_slider = () => {
    if ($(".card-info").length) {
        var paragraphHeight = 0;
        var headingHeight = 0;

        $('.card-info > p, .card-info > h3').each(function () {
            var elementHeight = $(this).height();

            if ($(this).is('p')) {
                paragraphHeight = Math.max(paragraphHeight, elementHeight);
            } else if ($(this).is('h3')) {
                headingHeight = Math.max(headingHeight, elementHeight);
            }
        });

        $('.card-info > p').css('min-height', paragraphHeight);
        $('.card-info > h3').css('min-height', headingHeight);
    }
}

export default textHeight_slider;